export default __webpack_public_path__ + "static/media/rounded-train-2x.70540ba9.webp";